export class MetaData {
  id: number | null = null;
  parentId: number | string | null = null;
  parentExternalId: string | null = null;
  updateBy: string | null = null;
  updateTime: Date | null = null;
  key: string | null = null;
  value: string | null = null;
}